import React from 'react';
import Navbar from './Navbar';
import Header from './Header';

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <Navbar />
      {children}
    </>
  );
};

export default Layout;
